import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import CodeFormStyle from './CodeFormStyle'
import type { CodeFormBrandType, CodeBrandForms } from './codeTypes'

const FORM_MAP: CodeBrandForms = {
  [BrandFormEnum.STYLE]: CodeFormStyle,
}

const CodeFormBrand: CodeFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(CodeFormBrand) as typeof CodeFormBrand
